import React, { Component } from "react";
import { ProjectProperty } from "@eres/ejari-api/Entity/LeasedProperties";
import ListDataView from "@my-dld/components/DataView/ListDataView";
import Strings from "@my-dld/assets/strings";
import { EjariPropertyType } from "@eres/ejari-api/Entity";
import { showOnMap } from "@my-dld/utils/Utils";
import CardNoData from "@my-dld/components/CardNoData";
import {
	getProjectPropertyArea,
	getProjectPropertyBuilding,
	getProjectPropertyBuildingCount,
	getProjectPropertyType
} from "../../screens/Leased/ProjectProperties";

export interface ProjectPropertyProps {
	properties: ProjectProperty[];
	onPropertySelect: ( property: ProjectProperty ) => void;
}

class ProjectPropertiesListView extends Component<ProjectPropertyProps> {
	render() {
		const { properties, onPropertySelect } = this.props;
		return <React.Fragment>
			<ListDataView
				items={ properties }
				renderListHeader={ () => <RenderHeader/> }
				renderListItem={ ( item: ProjectProperty, index: number ) => {
					return <RenderListItem
						key={ "project_buildings_grid_" + index }
						property={ item }
						onPropertySelect={ onPropertySelect }/>;
				} }/>
			{ properties.length === 0 && <CardNoData containerClass="alert alert-warning"/> }
		</React.Fragment>;
	}
}

export function RenderHeader() {
	return <tr>
		<th>{ Strings.area }</th>
		<th>{ Strings.building_name + " / " + Strings.villa_name }</th>
		<th>{ Strings.no_of_properties + " / " + Strings.no_of_bed_rooms }</th>
		<th>{ Strings.locate_on_map }</th>
		<th>{ " " }</th>
	</tr>;
}

export function RenderListItem( props: {
	property: ProjectProperty,
	onPropertySelect: ( property: ProjectProperty ) => void
} ) {
	const { property, onPropertySelect } = props;
	const isBuilding = ( property.PropertyTypeId === EjariPropertyType.BUILDING );
	return ( <tr>
			<td data-label={ Strings.area }>{ getProjectPropertyArea( property ) }</td>
			<td data-label={ Strings.building_name }>{ getProjectPropertyBuilding( property ) }</td>
			{ isBuilding &&
				<td data-label={ Strings.no_of_properties + " / " + Strings.no_of_bed_rooms }>{ getProjectPropertyBuildingCount( property ) }</td> }
			{ !isBuilding &&
				<td data-label={ Strings.no_of_properties + " / " + Strings.no_of_bed_rooms }>{ getProjectPropertyType( property ) }</td> }
			<td data-label={ Strings.locate_on_map }>{ property.Latitude && property.Longitude &&
				<a onClick={ () => showOnMap( property.Latitude!, property.Longitude! ) }>
					<i className="fa fa-map-marker-alt"/>
				</a>
			}</td>
			<td data-label="Action" className="text-start">
				<button
					type="button" className="btn underline p-0 font-size14"
					onClick={ () => onPropertySelect( property ) }>
					{ isBuilding ? Strings.view_units : Strings.view_details }
				</button>
			</td>
		</tr>
	);
}

export default ProjectPropertiesListView;
